import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { type ReactNode, useState } from 'react';

/**
 * Provider do TanStack Query.
 *
 * QueryClient é criado dentro de useState pra garantir 1 instância por
 * mount (não nasce a cada render). Defaults conservadores: 30s de
 * staleTime, sem refetch on focus (B2B SaaS rarely needs).
 *
 * Devtools só em dev (drop em prod via tree-shaking porque `import.meta.env.DEV`
 * é constante de build).
 */
export function QueryProvider({ children }: { readonly children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
          mutations: {
            retry: 0,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={client}>
      {children}
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />}
    </QueryClientProvider>
  );
}
